import(/* webpackMode: "eager" */ "/app/assets/images/advertisement/icons/apple_store.svg");
;
import(/* webpackMode: "eager" */ "/app/assets/images/advertisement/icons/facebook.svg");
;
import(/* webpackMode: "eager" */ "/app/assets/images/advertisement/icons/google_play.svg");
;
import(/* webpackMode: "eager" */ "/app/assets/images/advertisement/icons/instagram.svg");
;
import(/* webpackMode: "eager" */ "/app/assets/images/advertisement/icons/x.svg");
;
import(/* webpackMode: "eager" */ "/app/assets/images/advertisement/icons/youtube.svg");
;
import(/* webpackMode: "eager" */ "/app/assets/images/brand-logo.svg");
;
import(/* webpackMode: "eager" */ "/app/assets/images/logo-icon.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/graphql/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/customLink/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/header/headerWraper/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/myImage/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/shared/components/NProgress/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/scripts/bodyComponents/adsScript/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/stickyBottomAdd/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/shared/components/Toast/index.tsx");
